import {combineReducers} from 'redux';
import _ from 'lodash';
import { v1 as uuidv1 } from 'uuid';
import {
    CLEAN_SUBMITTING,
    SET_CREDENCIAL,
    SET_EMBEDDED,
    SET_LOADING,
    SET_MESSAGE,
    SET_MODULES,
    SET_SELECT_OPTIONS,
    SET_SHOW_HEADER,
    SET_SUBMITTING,
    SET_SUBMITTING_PROGRESS
} from '../actions/actionTypes.js';
import {MESSAGE_INFO} from '../constants/index.js';

const currentYear = String(new Date().getFullYear());

const initialState = {
    isLoading: false,
    message: {
        id: null,
        type: MESSAGE_INFO,
        text: null
    },
    submit: {
        isSubmitting: false,
        progress: 0
    },
    credencial: '',
    embedded: false,
    showHeader: true,
    modules: [],
    selectOptions: {
        campusSelecionado: null,
        cursoSelecionado: null,
        anoSelecionado: currentYear,
        semestreSelecionado: '1'
    }
};

const isLoading = (state = initialState.isLoading, action) => {
    switch (action.type) {
        case SET_LOADING:
            return action.isLoading;
        default:
            return state;
    }
};

const message = (state = initialState.message, action) => {
    switch (action.type) {
        case SET_MESSAGE:
            return _.assign({}, state, { 
                id: uuidv1(), 
                type: action.typeMessage, 
                text: action.text 
            });
        default:
            return state;
    }
};

const credencial = (state = initialState.credencial, action) => {
    switch (action.type) {
        case SET_CREDENCIAL:
            return action.credencial ? action.credencial : '';
        default:
            return state;
    }
};

const embedded = (state = initialState.embedded, action) => {
    switch (action.type) {
        case SET_EMBEDDED:
            return action.embedded ? action.embedded : false;
        default:
            return state;
    }
};

const showHeader = (state = initialState.showHeader, action) => {
    switch (action.type) {
        case SET_SHOW_HEADER:
            return action.showHeader !== undefined ? action.showHeader : true;
        default:
            return state;
    }
};

const modules = (state = initialState.modules, action) => {
    switch (action.type) {
        case SET_MODULES:
            return [...action.modules];
        default:
            return state;
    }
};

const selectOptions = (state = initialState.selectOptions, action) => {
    switch (action.type) {
        case SET_SELECT_OPTIONS:
            return _.assign({}, state, action.options);
        default:
            return state;
    }
};

const submit = (state = initialState.submit, action) => {
    switch (action.type) {
        case SET_SUBMITTING:
            return _.assign({}, state, {isSubmitting: action.isSubmitting});
        case SET_SUBMITTING_PROGRESS:
            return _.assign({}, state, {progress: action.progress});
        case CLEAN_SUBMITTING:
            return {...initialState.submit}
        default:
            return state;
    }
};

const reducer = combineReducers({
    isLoading,
    message,
    credencial,
    embedded,
    showHeader,
    modules,
    selectOptions,
    submit
});

export default reducer;
